import { BaseEntityWithMultilanguageName } from '../BaseEntity';

export class MooringFrameOrderCateogry extends BaseEntityWithMultilanguageName {
  static ApiUrl = 'api/mooring-frame-order-categories';
}
